import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Shield, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 max-w-4xl mx-auto px-4 py-8 w-full">
        <Link to="/" className="text-green-500 hover:underline text-sm flex items-center gap-1 mb-6">
          <ArrowLeft className="w-4 h-4" />
          Torna alla home
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <Shield className="w-10 h-10 text-green-500" />
          <h1 className="text-3xl sm:text-4xl font-bold text-white">INFORMATIVA PRIVACY</h1>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 sm:p-8 space-y-6 text-zinc-300">
          
          <p className="text-zinc-400 text-sm">
            Ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR)
          </p>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Titolare del trattamento</h2>
            <p>
              Il/La sottoscritto/a è informato/a che il titolare del trattamento dei suoi dati personali è <strong className="text-white">Pregiato s.r.l.s.</strong>, sita in Assisi (PG), via Dionigi della Torre n. 3, 06081.
            </p>
            <p className="mt-3">
              <strong className="text-white">Responsabile della Protezione dei Dati (DPO):</strong>
            </p>
            <p>
              Pregiato s.r.l.s., indirizzo mail: <a href="mailto:pregiatosrls@gmail.com" className="text-green-500 hover:underline">pregiatosrls@gmail.com</a>, telefono: <a href="tel:3454688001" className="text-green-500 hover:underline">345 4688001</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Finalità del trattamento dei dati</h2>
            <p>I dati personali sono trattati per le seguenti finalità:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-2">
              <li>Gestire gli ordini</li>
              <li>Effettuare le consegne</li>
              <li>Comunicare con l'utente in merito al servizio</li>
            </ul>
            <p className="mt-3">Se l'utente acconsente, i dati possono essere utilizzati anche per:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-2">
              <li>Invio di offerte e comunicazioni promozionali</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Base giuridica del trattamento</h2>
            <p>Il trattamento dei dati è lecito in quanto basato su:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-2">
              <li>Consenso dell'interessato per finalità promozionali</li>
              <li>Esecuzione del servizio richiesto</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Tipi di dati personali trattati</h2>
            <p>I dati personali oggetto del trattamento comprendono:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-2">
              <li>Dati anagrafici (es. nome, cognome)</li>
              <li>Dati di contatto (es. e-mail, telefono)</li>
              <li>Altri dati forniti direttamente dall'interessato: ____________</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Destinatari o categorie di destinatari</h2>
            <p>I suoi dati potranno essere comunicati a:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-2">
              <li>Personale interno autorizzato dal titolare</li>
              <li>Autorità o enti pubblici solo se previsto da legge</li>
            </ul>
            <p className="mt-3">I dati non saranno diffusi pubblicamente.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Trasferimenti verso paesi terzi o organizzazioni internazionali</h2>
            <p>I dati non saranno trasferiti fuori dall'Unione Europea</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Periodo di conservazione</h2>
            <p>
              I suoi dati saranno conservati per il tempo necessario alle finalità indicate, non oltre i termini previsti per la durata del rapporto sanciti dalla legge.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Diritti dell'interessato</h2>
            <p>Il/La sottoscritto/a ha il diritto di esercitare, nei confronti del titolare, i diritti previsti dagli artt. 15–22 del GDPR, tra cui:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-2">
              <li>accesso ai dati in possesso del titolare</li>
              <li>rettifica o cancellazione dei dati</li>
              <li>limitazione del trattamento</li>
              <li>opposizione al trattamento</li>
              <li>portabilità dei dati</li>
              <li>revoca del consenso (se prestato) senza pregiudicare la liceità del trattamento basato sul consenso prima della revoca</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Diritto di reclamo</h2>
            <p>
              Il/La sottoscritto/a ha il diritto di proporre reclamo all'Autorità Garante per la protezione dei dati personali qualora ritenga che il trattamento non sia conforme alla normativa vigente.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Conferimento dei dati</h2>
            <p>
              Il conferimento dei dati è obbligatorio per l'esecuzione delle finalità di cui sopra (es. contrattuali o legali).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">Automated decision-making / profilazione</h2>
            <p>
              Il trattamento non prevede processi automatizzati decisionali né profilazione
            </p>
          </section>

          <div className="border-t border-zinc-700 pt-6 mt-6">
            <p className="text-zinc-400">
              <strong className="text-white">Ultimo aggiornamento</strong>
            </p>
            <p className="text-zinc-400">29/03/2026</p>
            <p className="text-zinc-400 mt-3">
              Pregiato s.r.l.s.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
